


import { Padding } from '@mui/icons-material';
import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { Link } from 'react-router-dom';
import ClipLoader from "react-spinners/ClipLoader";
import { useLoader } from '../../../../context/LoaderProvider';

const ScheduleOrder = () => {
    const [orders, setOrders] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [vendorId, setVendorId] = useState(null);
    const [loading, setLoading] = useState(false);
    const { showLoader, hideLoader } = useLoader();
    const [showDetails, setShowDetails] = useState({});
    const isMobile = window.innerWidth <= 768;
    const screenWidth = window.innerWidth;
    const containerHeight = window.innerWidth < 768
        ? '300px'
        : window.innerWidth < 850
            ? '300px'
            : window.innerWidth < 1400
                ? '410px'
                : window.innerWidth < 1600
                    ? '500px'
                    : '640px';

    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);

    useEffect(() => {
        if (!vendorId) return;

        const fetchOrders = async () => {
            const token = localStorage.getItem("authToken");
            const employeeRole = localStorage.getItem("employeRole");
            const role = localStorage.getItem("role");

            if (!token) return;

            setLoading(true);
            showLoader();

            try {
                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/orders/status-range`,
                    {
                        params: {
                            vendorId: vendorId,
                            fromStatus: "HOLD",
                            toStatus: "HOLD"
                        },
                        headers: { Authorization: `Bearer ${token}` }
                    }
                );

                let holdOrders = response.data || [];

                const tableHoldRes = await axios.get(
                    `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/HOLD`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                const tableHoldOrders = tableHoldRes.data || [];

                let combinedOrders = [
                    ...holdOrders,
                    ...tableHoldOrders,
                ];

                // Filter orders where sheduled is true
                combinedOrders = combinedOrders.filter(order => order.sheduled === true);

                combinedOrders.sort((a, b) => {
                    const dateA = new Date(a.orderDateAndTime || a.createdAt || 0);
                    const dateB = new Date(b.orderDateAndTime || b.createdAt || 0);
                    return dateA - dateB;
                });

                const validChefTypes = ["Chef_North", "Chef_South", "Chef_Continental", "Chef_Chinese"];

                if (role === "ROLE_VENDOR") {
                } else if (employeeRole && validChefTypes.includes(employeeRole)) {
                    combinedOrders = combinedOrders.filter((order) =>
                        (order.cartItems || order.order)?.some(
                            (item) => item.chefType && item.chefType === employeeRole
                        )
                    );
                } else {
                    console.warn("⚠️ No valid employee role found — showing no filtered data.");
                }

                setOrders(combinedOrders);
            } catch (error) {
                console.error("❌ Failed to fetch HOLD orders:", error.response?.data || error.message);
            } finally {
                setLoading(false);
                hideLoader();
            }
        };

        fetchOrders();
    }, [vendorId]);

    const handleItemSelect = (orderId, index) => {
        setSelectedItems((prev) => {
            const existing = prev[orderId] || [];
            const updated = existing.includes(index)
                ? existing.filter((i) => i !== index)
                : [...existing, index];
            return { ...prev, [orderId]: updated };
        });
    };

    const orderStages = ["On Hold", "Resume"];

    const styles = {
        card: { border: '1px solid #ccc', padding: '16px', margin: '16px', borderRadius: '10px', background: "linear-gradient(to right, #f46b45, #eea849)" },
        header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
        orderId: { margin: 0, fontWeight: "bold" },
        date: { fontSize: '18px', color: '#555', fontWeight: "bold" },
        pickupBtn: { background: '#28a745', color: '#fff', border: 'none', padding: '6px 12px', cursor: 'pointer', borderRadius: '5px', fontWeight: "bold" },
        tracker: { marginTop: '10px', display: 'flex', alignItems: 'center', fontWeight: "bold" },
        statusBox: { background: '#eee', padding: '8px 12px', borderRadius: '5px' },
        arrow: { margin: '0 5px' },
        dropdownBtn: {
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            ...(screenWidth >= 1000 && screenWidth <= 1200 ? { marginLeft: '90px' } : {}),
        },
        itemList: { marginTop: '10px', fontWeight: "bold" },
        itemRow: { display: 'flex', justifyContent: 'space-between', padding: '4px 0', borderBottom: '1px solid #ddd' }
    };

    // Function to handle Accept/Confirm button
    const handleAcceptClick = async (order) => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("Authorization token missing");
            return;
        }

        showLoader();

        try {
            if (order.orderType === "TABLE_DINE_IN") {
                const status = "CONFIRMED";
                const note = "Order confirmed from HOLD";
                const updatePromises = order.cartItems.map((item) =>
                    axios.put(
                        `https://backend.maamaas.com/food/api/cart/cartitem/status/${item.itemId}?status=${status}&note=${encodeURIComponent(note)}`,
                        {},
                        { headers: { Authorization: `Bearer ${token}` } }
                    )
                );
                await Promise.all(updatePromises);
                setOrders((prev) =>
                    prev.filter((o) => o.cartId !== order.cartId)
                );
                alert(`✅ Order #${order.cartId} has been confirmed successfully!`);
            } else {
                await axios.put(
                    `https://backend.maamaas.com/food/api/orders/edit-orders/${order.orderId}/CONFIRMED`,
                    { status: "CONFIRMED" },
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                setOrders((prev) =>
                    prev.filter((o) => o.orderId !== order.orderId)
                );
                alert(`✅ Order #${order.orderId} has been confirmed successfully!`);
            }
        } catch (error) {
            console.error("❌ Failed to confirm order from HOLD:", error.response?.data || error.message);
            alert("❌ Failed to confirm order. Please try again.");
        } finally {
            hideLoader();
        }
    };

    const handleCancelClick = async (order) => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("Authorization token missing");
            return;
        }

        if (!window.confirm(`Are you sure you want to cancel order #${order.orderId || order.cartId}?`)) {
            return;
        }

        const reason = prompt("Please enter cancellation reason:");
        if (!reason || reason.trim() === "") {
            alert("Cancellation reason is required.");
            return;
        }

        showLoader();

        try {
            if (order.orderType === "TABLE_DINE_IN") {
                const status = "CANCELLED";
                const updatePromises = order.cartItems.map((item) =>
                    axios.put(
                        `https://backend.maamaas.com/food/api/cart/cartitem/status/${item.itemId}?status=${status}&note=${encodeURIComponent(`Cancelled: ${reason}`)}`,
                        {},
                        { headers: { Authorization: `Bearer ${token}` } }
                    )
                );
                await Promise.all(updatePromises);
                setOrders((prev) =>
                    prev.filter((o) => o.cartId !== order.cartId)
                );
                alert(`✅ Order #${order.cartId} has been cancelled successfully!`);
            } else {
                await axios.put(
                    `https://backend.maamaas.com/food/api/orders/edit-orders/${order.orderId}/CANCELLED`,
                    {
                        status: "CANCELLED",
                        note: reason
                    },
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                setOrders((prev) =>
                    prev.filter((o) => o.orderId !== order.orderId)
                );
                alert(`✅ Order #${order.orderId} has been cancelled successfully!`);
            }
        } catch (error) {
            console.error("❌ Failed to cancel order:", error.response?.data || error.message);
            alert("❌ Failed to cancel order. Please try again.");
        } finally {
            hideLoader();
        }
    };

    // Helper function to format time
    const formatTime = (timeString) => {
        if (!timeString) return "N/A";
        try {
            // Check if it's already in HH:MM:SS format
            if (timeString.includes(':')) {
                const [hours, minutes] = timeString.split(':');
                const hour = parseInt(hours);
                const ampm = hour >= 12 ? 'PM' : 'AM';
                const displayHour = hour % 12 || 12;
                return `${displayHour}:${minutes} ${ampm}`;
            }
            return timeString;
        } catch (e) {
            return timeString;
        }
    };

    // New function to format schedule date and time
    const formatScheduleDateTime = (order) => {
        if (!order.date || !order.time) return "N/A";

        try {
            // Format date
            const dateObj = new Date(order.date);
            const formattedDate = dateObj.toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
            });

            // Format time
            const formattedTime = formatTime(order.time);

            return `${formattedDate} ${formattedTime}`;
        } catch (e) {
            console.error("Error formatting schedule date/time:", e);
            return "N/A";
        }
    };

    return (
        <div className="container-flui">
            <div className="schedule-managment" style={{ marginTop: isMobile ? "0px" : "00px" }}>
                {loading ? (
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
                        <ClipLoader color="#ff4081" size={60} />
                    </div>
                ) : (
                    <div style={{
                        overflow: "auto",
                        height: window.innerHeight < 500 ? "40vh" : window.innerHeight < 600 ? "50vh" : window.innerHeight < 700 ? "65vh" : window.innerHeight < 800 ? "70vh" : window.innerHeight < 900 ? "68vh" : containerHeight,
                        scrollbarWidth: "thin"
                    }} >
                        {orders.length === 0 ? (
                            <div style={{
                                textAlign: 'center',
                                padding: '50px',
                                fontSize: '18px',
                                color: '#666'
                            }}>
                                No orders on Schedule at the moment.
                            </div>
                        ) : (
                            orders.map((order) => {
                                const orderItems = order.orderType === "TABLE_DINE_IN" ? order.cartItems || [] : order.order || [];
                                const orderId = order.orderId || order.cartId;
                                const selected = selectedItems[orderId] || [];

                                return (
                                    <div key={orderId} style={{
                                        border: '1px solid #ccc',
                                        padding: '16px',
                                        margin: '16px',
                                        marginRight: window.innerWidth < 769 ? "16px" : "0px",
                                        borderRadius: '10px',
                                        background: (() => {
                                            const normalized = (order.orderType || "").trim().toLowerCase();
                                            switch (normalized) {
                                                case "dine_in": return "#1E90FF";
                                                case "takeaway": return "#FF6347";
                                                case "delivery": return "#20B2AA";
                                                case "table_dine_in": return "#2051b2ff";
                                                default: return "#b15cd6";
                                            }
                                        })(),
                                    }}>
                                        {/* Header Section */}
                                        <div style={styles.header}>
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: window.innerWidth < 1300 ? 'column' : 'row',
                                                justifyContent: 'space-between',
                                                alignItems: window.innerWidth < 1300 ? 'stretch' : 'center',
                                                gap: window.innerWidth < 1300 ? '10px' : '0',
                                                width: '100%',
                                                padding: '5px 0',
                                            }}>

                                                {/* First Line: Order ID and Date/Time */}
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: window.innerWidth <= 500 ? 'start' : 'center',
                                                    width: '100%',
                                                    flexDirection: window.innerWidth <= 500 ? "column" : "row",
                                                    marginLeft: window.innerWidth <= 370 ? "-1rem" : " ",
                                                    gap: window.innerWidth <= 370 ? '0px' : '10px',
                                                    padding: window.innerWidth < 1300 ? '0 5px' : '0',
                                                }}>
                                                    <div style={{
                                                        ...styles.orderId,
                                                        margin: 0,
                                                        fontSize: window.innerWidth <= 370 ? '14px' : '17px',
                                                        fontWeight: 'bold',
                                                        color: "black",
                                                        whiteSpace: 'nowrap',
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        width: "100%",
                                                    }}>
                                                        <div style={{ flex: "0 0 auto" }}>
                                                            ORDER ID : <span style={{
                                                                fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem",
                                                                color: "white"
                                                            }}>#{orderId}</span>
                                                        </div>

                                                        <div style={{ flex: "0 0 auto", marginLeft: "10px" }}>
                                                            <button style={{
                                                                background: '#28a745',
                                                                color: '#fff',
                                                                border: 'none',
                                                                padding: window.innerWidth < 1100 ? "5px 10px" : '6px 15px',
                                                                borderRadius: '4px',
                                                                fontWeight: 'bold',
                                                                fontSize: '14px',
                                                                whiteSpace: 'nowrap',
                                                                cursor: 'default',
                                                                display: window.innerWidth <= 450 ? "block" : "none",
                                                            }}>
                                                                {order.orderType === 'DINE_IN' ? 'DINEIN' : order.orderType}
                                                            </button>
                                                        </div>
                                                    </div>

                                                    {order.orderDateAndTime && (
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            fontSize: window.innerWidth <= 370 ? '14px' : '16px',
                                                            color: '#000000ff',
                                                            fontWeight: '500',
                                                            whiteSpace: 'nowrap',
                                                        }}>
                                                            <span style={{ whiteSpace: 'nowrap' }}>
                                                                {(() => {
                                                                    const dateObj = new Date(order.orderDateAndTime);
                                                                    const date = dateObj.toLocaleDateString('en-IN', {
                                                                        day: '2-digit',
                                                                        month: 'short',
                                                                        year: 'numeric',
                                                                    });
                                                                    const time = dateObj.toLocaleTimeString('en-IN', {
                                                                        hour: '2-digit',
                                                                        minute: '2-digit',
                                                                        hour12: true,
                                                                    });
                                                                    return (
                                                                        <>
                                                                            <span style={{ color: '#000000ff', fontWeight: 'bold', fontSize: window.innerWidth <= 370 ? '14px' : '17px', }}>DATE:</span>
                                                                            <span style={{ color: '#ffffffff', marginRight: '10px', marginLeft: "5px", fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem" }}>{date}</span>
                                                                            <span style={{ color: '#000000ff', fontWeight: 'bold', fontSize: window.innerWidth <= 370 ? '14px' : '17px', }}>TIME:</span>
                                                                            <span style={{ color: '#ffffffff', marginLeft: "5px", fontSize: window.innerWidth <= 500 ? "1rem" : "1.3rem" }}>{time}</span>
                                                                        </>
                                                                    );
                                                                })()}
                                                            </span>
                                                            <button
                                                                style={{
                                                                    background: 'none',
                                                                    border: '0px solid #ccc',
                                                                    borderRadius: '4px',
                                                                    padding: '6px 12px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '14px',
                                                                    minWidth: '40px',
                                                                    display: window.innerWidth > 1299 ? "none" : "block",
                                                                }}
                                                                onClick={() =>
                                                                    setShowDetails((prev) => ({
                                                                        ...prev,
                                                                        [orderId]: !prev[orderId],
                                                                    }))
                                                                }
                                                            >
                                                                {showDetails[orderId] ? '▲' : '▼'}
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Second Line: Order Type, Status, and Dropdown */}
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: window.innerWidth < 1300 ? 'flex-end' : 'end',
                                                    alignItems: 'center',
                                                    gap: window.innerWidth >= 1300 && window.innerWidth < 1350 ? '5px' : '15px',
                                                    width: '100%',
                                                    padding: window.innerWidth < 1300 ? '5px 5px 0 5px' : '0',
                                                    flexWrap: 'wrap',
                                                }}>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <button style={{
                                                            background: '#28a745',
                                                            color: '#fff',
                                                            border: 'none',
                                                            padding: '6px 15px',
                                                            borderRadius: '4px',
                                                            fontWeight: 'bold',
                                                            fontSize: '14px',
                                                            whiteSpace: 'nowrap',
                                                            cursor: 'default',
                                                            display: window.innerWidth > 450 ? "block" : "none",
                                                        }}>
                                                            {order.orderType === 'DINE_IN' ? 'DINEIN' : (order.service || order.orderType || 'Service')}
                                                        </button>
                                                    </div>

                                                    <button
                                                        style={{
                                                            background: 'none',
                                                            border: '0px solid #ccc',
                                                            borderRadius: '4px',
                                                            padding: '6px 12px',
                                                            cursor: 'pointer',
                                                            fontSize: '14px',
                                                            minWidth: '40px',
                                                            display: window.innerWidth > 1299 ? "block" : "none",
                                                        }}
                                                        onClick={() =>
                                                            setShowDetails((prev) => ({
                                                                ...prev,
                                                                [orderId]: !prev[orderId],
                                                            }))
                                                        }
                                                    >
                                                        {showDetails[orderId] ? '▲' : '▼'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Order Details */}
                                        {showDetails[orderId] && (
                                            <>
                                                <div style={{
                                                    marginTop: window.innerWidth < 450 ? '-1rem' : '0rem',
                                                    margin: window.innerWidth < 500 ? "0px 0%" : window.innerWidth >= 1200 ? " 0px 2%" : "0px 0%",
                                                    paddingTop: '10px',
                                                    overflow: "auto",
                                                }}>
                                                    {/* Fixed height container for table scrolling */}
                                                    <div style={{
                                                        width: '100%',
                                                        maxHeight: window.innerWidth <= 768 ? '350px' : 'auto',
                                                        overflow: window.innerWidth <= 768 ? 'auto' : 'visible',
                                                        overflowX: window.innerWidth <= 768 ? 'auto' : 'visible',
                                                        overflowY: window.innerWidth <= 768 ? 'hidden' : 'visible',
                                                        WebkitOverflowScrolling: 'touch',
                                                        position: 'relative',
                                                        scrollbarWidth: 'thin',
                                                        msOverflowStyle: 'none',
                                                        borderRadius: '8px',
                                                        border: window.innerWidth <= 768 ? '2px solid #b15cd6' : 'none'
                                                    }}>
                                                        {/* Custom scrollbar styles */}
                                                        <style>
                                                            {`
                        /* Horizontal scrollbar only */
                        .table-scroll-container::-webkit-scrollbar {
                            height: 6px;
                            width: 6px;
                        }
                        .table-scroll-container::-webkit-scrollbar-track {
                            background: rgba(177, 92, 214, 0.1);
                            border-radius: 3px;
                            margin: 4px;
                        }
                        .table-scroll-container::-webkit-scrollbar-thumb {
                            background: #b15cd6;
                            border-radius: 3px;
                        }
                        .table-scroll-container::-webkit-scrollbar-thumb:hover {
                            background: #9a4bc2;
                        }
                        /* Hide vertical scrollbar */
                        .table-scroll-container::-webkit-scrollbar:vertical {
                            display: none;
                        }
                    `}
                                                        </style>

                                                        {/* Traditional Table */}
                                                        <table style={{
                                                            width: window.innerWidth <= 768 ? 'max-content' : '100%',
                                                            minWidth: window.innerWidth <= 768 ? '650px' : '100%',
                                                            borderCollapse: 'collapse',
                                                            border: window.innerWidth <= 768 ? 'none' : '2px solid #b15cd6',
                                                            background: 'transparent',
                                                            borderRadius: window.innerWidth <= 768 ? '0' : '8px',
                                                            overflow: 'hidden',
                                                            boxShadow: window.innerWidth <= 768 ? 'none' : '0 4px 12px rgba(0, 0, 0, 0.1)'
                                                        }}>
                                                            {/* HEADER ROW */}
                                                            <thead>
                                                                <tr style={{
                                                                    background: '#b15cd6',
                                                                    borderBottom: '2px solid #9a4bc2',
                                                                    position: window.innerWidth <= 768 ? 'sticky' : 'static',
                                                                    top: 0,
                                                                    left: 0,
                                                                    zIndex: 10
                                                                }}>
                                                                    <th style={{
                                                                        textAlign: 'center',
                                                                        color: 'Black',
                                                                        fontWeight: 'bold',
                                                                        fontSize: window.innerWidth <= 370 ? '12px' : window.innerWidth <= 768 ? '13px' : '14px',
                                                                        padding: window.innerWidth <= 768 ? '10px 8px' : '12px 8px',
                                                                        borderRight: '1px solid rgba(255, 255, 255, 0.3)',
                                                                        minWidth: '120px',
                                                                        position: 'sticky',
                                                                        left: 0,
                                                                        background: '#b15cd6',
                                                                        zIndex: 11
                                                                    }}>
                                                                        Name
                                                                    </th>
                                                                    <th style={{
                                                                        textAlign: 'center',
                                                                        color: 'Black',
                                                                        fontWeight: 'bold',
                                                                        fontSize: window.innerWidth <= 370 ? '12px' : window.innerWidth <= 768 ? '13px' : '14px',
                                                                        padding: window.innerWidth <= 768 ? '10px 8px' : '12px 8px',
                                                                        borderRight: '1px solid rgba(255, 255, 255, 0.3)',
                                                                        minWidth: '120px'
                                                                    }}>
                                                                        Mobile No.
                                                                    </th>
                                                                    <th style={{
                                                                        textAlign: 'center',
                                                                        color: 'Black',
                                                                        fontWeight: 'bold',
                                                                        fontSize: window.innerWidth <= 370 ? '12px' : window.innerWidth <= 768 ? '13px' : '14px',
                                                                        padding: window.innerWidth <= 768 ? '10px 8px' : '12px 8px',
                                                                        borderRight: '1px solid rgba(255, 255, 255, 0.3)',
                                                                        minWidth: '140px'
                                                                    }}>
                                                                        Schedule Time
                                                                    </th>
                                                                    <th style={{
                                                                        textAlign: 'center',
                                                                        color: 'Black',
                                                                        fontWeight: 'bold',
                                                                        fontSize: window.innerWidth <= 370 ? '12px' : window.innerWidth <= 768 ? '13px' : '14px',
                                                                        padding: window.innerWidth <= 768 ? '10px 8px' : '12px 8px',
                                                                        borderRight: '1px solid rgba(255, 255, 255, 0.3)',
                                                                        minWidth: '160px'
                                                                    }}>
                                                                        Item
                                                                    </th>
                                                                    <th style={{
                                                                        textAlign: 'center',
                                                                        color: 'Black',
                                                                        fontWeight: 'bold',
                                                                        fontSize: window.innerWidth <= 370 ? '12px' : window.innerWidth <= 768 ? '13px' : '14px',
                                                                        padding: window.innerWidth <= 768 ? '10px 8px' : '12px 8px',
                                                                        minWidth: '80px',
                                                                        position: 'sticky',
                                                                        right: 0,
                                                                        background: '#b15cd6',
                                                                        zIndex: 11
                                                                    }}>
                                                                        Qty
                                                                    </th>
                                                                </tr>
                                                            </thead>

                                                            <tbody>
                                                                {/* VALUES ROW */}
                                                                <tr style={{
                                                                    borderBottom: '1px solid rgba(255, 255, 255, 0.2)'
                                                                }}>
                                                                    <td style={{
                                                                        textAlign: 'center',
                                                                        padding: window.innerWidth <= 768 ? '12px 8px' : '15px 8px',
                                                                        borderRight: '1px solid rgba(255, 255, 255, 0.2)',
                                                                        fontSize: window.innerWidth <= 500 ? "0.9rem" : "1rem",
                                                                        color: '#ffffffff',
                                                                        fontWeight: '600',
                                                                        verticalAlign: 'middle',
                                                                        minWidth: '120px',
                                                                        position: 'sticky',
                                                                        left: 0,
                                                                        // background: (() => {
                                                                        //     const normalized = (order.orderType || "").trim().toLowerCase();
                                                                        //     switch (normalized) {
                                                                        //         case "dine_in": return "#FFA500";
                                                                        //         case "takeaway": return "#FF8C00";
                                                                        //         case "delivery": return "#FF7F50";
                                                                        //         case "table_dine_in": return "#FF6347";
                                                                        //         default: return "#FFA500";
                                                                        //     }
                                                                        // })(),
                                                                        zIndex: 9
                                                                    }}>
                                                                        {order.deliveryUserName || order.userName || "Guest"}
                                                                    </td>
                                                                    <td style={{
                                                                        textAlign: 'center',
                                                                        padding: window.innerWidth <= 768 ? '12px 8px' : '15px 8px',
                                                                        borderRight: '1px solid rgba(255, 255, 255, 0.2)',
                                                                        fontSize: window.innerWidth <= 500 ? "0.9rem" : "1rem",
                                                                        color: '#ffffffff',
                                                                        fontWeight: '600',
                                                                        verticalAlign: 'middle',
                                                                        minWidth: '120px'
                                                                    }}>
                                                                        {order.mobileNo || "-"}
                                                                    </td>
                                                                    <td style={{
                                                                        textAlign: 'center',
                                                                        padding: window.innerWidth <= 768 ? '12px 8px' : '15px 8px',
                                                                        borderRight: '1px solid rgba(255, 255, 255, 0.2)',
                                                                        fontSize: window.innerWidth <= 500 ? "0.85rem" : "0.95rem",
                                                                        color: '#ffffffff',
                                                                        fontWeight: '600',
                                                                        verticalAlign: 'middle',
                                                                        minWidth: '140px',
                                                                        wordBreak: 'break-all'
                                                                    }}>
                                                                        {formatScheduleDateTime(order)}
                                                                    </td>
                                                                    <td style={{
                                                                        textAlign: 'center',
                                                                        padding: window.innerWidth <= 768 ? '12px 8px' : '15px 8px',
                                                                        borderRight: '1px solid rgba(255, 255, 255, 0.2)',
                                                                        verticalAlign: 'middle',
                                                                        minWidth: '160px'
                                                                    }}>
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            flexDirection: 'column',
                                                                            alignItems: 'start',
                                                                            gap: window.innerWidth <= 768 ? '8px' : '10px'
                                                                        }}>
                                                                            {orderItems
                                                                                .filter((item) => item.status === "Okay" || item.orderType === "TABLE_DINE_IN")
                                                                                .map((item, index) => (
                                                                                    <div
                                                                                        key={index}
                                                                                        style={{
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            gap: window.innerWidth <= 768 ? '8px' : '10px',
                                                                                            justifyContent: 'center',
                                                                                            padding: '4px 0'
                                                                                        }}
                                                                                    >
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={!!selectedItems[item.listId || item.id || index]}
                                                                                            onChange={() => {
                                                                                                const id = item.listId || item.id || index;
                                                                                                setSelectedItems(prev => ({
                                                                                                    ...prev,
                                                                                                    [id]: !prev[id]
                                                                                                }));
                                                                                            }}
                                                                                            style={{
                                                                                                cursor: 'pointer',
                                                                                                width: window.innerWidth <= 768 ? '16px' : '18px',
                                                                                                height: window.innerWidth <= 768 ? '16px' : '18px',
                                                                                                accentColor: '#b15cd6',
                                                                                                flexShrink: 0
                                                                                            }}
                                                                                        />
                                                                                        <span style={{
                                                                                            fontSize: window.innerWidth <= 500 ? "0.8rem" : "0.9rem",
                                                                                            color: '#ffffffff',
                                                                                            fontWeight: '500',
                                                                                            whiteSpace: "nowrap",
                                                                                            overflow: 'hidden',
                                                                                            textOverflow: 'ellipsis',
                                                                                            maxWidth: window.innerWidth <= 768 ? '130px' : '150px'
                                                                                        }}>
                                                                                            {item.dishName}
                                                                                        </span>
                                                                                    </div>
                                                                                ))}
                                                                        </div>
                                                                    </td>
                                                                    <td style={{
                                                                        textAlign: 'center',
                                                                        padding: window.innerWidth <= 768 ? '12px 8px' : '15px 8px',
                                                                        verticalAlign: 'middle',
                                                                        minWidth: '80px',
                                                                        position: 'sticky',
                                                                        right: 0,

                                                                        zIndex: 9
                                                                    }}>
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            flexDirection: 'column',
                                                                            alignItems: 'center',
                                                                            gap: window.innerWidth <= 768 ? '8px' : '10px'
                                                                        }}>
                                                                            {orderItems
                                                                                .filter((item) => item.status === "Okay" || item.orderType === "TABLE_DINE_IN")
                                                                                .map((item, index) => (
                                                                                    <div
                                                                                        key={index}
                                                                                        style={{
                                                                                            fontSize: window.innerWidth <= 500 ? "0.9rem" : "1rem",
                                                                                            color: '#ffffffff',
                                                                                            fontWeight: 'bold',
                                                                                            padding: '4px 0',
                                                                                            minWidth: '25px'
                                                                                        }}
                                                                                    >
                                                                                        {item.quantity || 1}
                                                                                    </div>
                                                                                ))}
                                                                        </div>
                                                                    </td>
                                                                </tr>

                                                                {/* ADDRESS ROW */}
                                                                <tr>
                                                                    <td colSpan="5" style={{
                                                                        padding: '0px',
                                                                        background: 'rgba(177, 92, 214, 0.1)',
                                                                        minWidth: window.innerWidth <= 768 ? '650px' : 'auto'
                                                                    }}>
                                                                        <div style={{
                                                                            display: window.innerWidth < 500 ? 'flex' : 'grid',
                                                                            gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : 'auto 1fr',
                                                                            alignItems: 'center',
                                                                            gap: '0px',
                                                                            width: '100%'
                                                                        }}>
                                                                            <div style={{
                                                                                fontSize: '17px',
                                                                                color: 'black',
                                                                                fontWeight: 'bold',
                                                                                whiteSpace: 'nowrap',
                                                                                padding: window.innerWidth <= 768 ? '10px 12px' : '8px 12px',
                                                                                borderRadius: '4px',
                                                                                border: '0px solid #b15cd6',
                                                                                minWidth: window.innerWidth <= 768 ? '100px' : 'auto'
                                                                            }}>
                                                                                Address:
                                                                            </div>
                                                                            <div className='borderleft' style={{
                                                                                fontSize: window.innerWidth <= 500 ? "0.95rem" : "1.05rem",
                                                                                color: '#ffffffff',
                                                                                fontWeight: '500',
                                                                                wordBreak: 'break-word',
                                                                                alignItems: "center",
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                padding: window.innerWidth <= 768 ? '10px 15px' : '10px 15px',
                                                                                borderRadius: '0px',
                                                                                minWidth: window.innerWidth <= 768 ? '550px' : 'auto'
                                                                            }}>
                                                                                {order.deliveryAddress || "-"}
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        {/* Action Buttons Section */}
                                        <div style={{
                                            marginTop: '10px',
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "15px",
                                            flexWrap: "wrap"
                                        }}>
                                            <button
                                                onClick={() => handleAcceptClick(order)}
                                                style={{
                                                    backgroundColor: "#28a745",
                                                    color: "white",
                                                    border: "none",
                                                    borderRadius: "6px",
                                                    padding: "8px 20px",
                                                    fontWeight: "bold",
                                                    textTransform: "uppercase",
                                                    cursor: "pointer",
                                                    transition: "all 0.3s ease",
                                                    fontSize: window.innerWidth < 1300 ? "0.9rem" : "1rem",
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px"
                                                }}
                                            >
                                                Accept
                                            </button>

                                            <button
                                                onClick={() => handleCancelClick(order)}
                                                style={{
                                                    backgroundColor: "#dc3545",
                                                    color: "white",
                                                    border: "none",
                                                    borderRadius: "6px",
                                                    padding: "8px 20px",
                                                    fontWeight: "bold",
                                                    textTransform: "uppercase",
                                                    cursor: "pointer",
                                                    transition: "all 0.3s ease",
                                                    fontSize: window.innerWidth < 1300 ? "0.9rem" : "1rem",
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px"
                                                }}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                )}

            </div>
        </div>
    );
};

export default ScheduleOrder;